import { render, staticRenderFns } from "./DetailTeamMeasure.vue?vue&type=template&id=331aa558"
import script from "./DetailTeamMeasure.vue?vue&type=script&lang=js"
export * from "./DetailTeamMeasure.vue?vue&type=script&lang=js"
import style0 from "./DetailTeamMeasure.vue?vue&type=style&index=0&id=331aa558&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports